// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"SubTitle_subtitle__hYajj"};